<template lang="pug">
.receive-message-list-tab(v-cloak)
  .box-body
    .opinion-history.d-flex.flex-row.flex-nowrap.align-items-stretch
      // left side list
      .receive-message-list.d-flex.flex-column.receive-message-list-table-component
        // テーブル
        b-table(
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filter-included-fields="filterFields"
          :busy="isLoading"
          sticky-header
          no-border-collapse
          table-class="message-table opinion-message-table"
          show-empty
          :filter-function="filterTable"
          @filtered="onFiltered"
        )
          // ローディング
          template(#table-busy)
            .text-center.table-loading-message
              b-spinner.spinner
              span.message.align-self-center 読込み中...
          // レコード無し
          template(#empty)
            .empty-message
              span 情報がありません
          // フィルター後レコード無し
          template(#emptyfiltered)
            .empty-message
              span 情報がありません

          // セル：施設関係者ユーザー
          template(#cell(familyMessage)="row")
            .opinion-row(@click="selectOpinion(row.item)" :class="{ selected : row.item.selected }")
              .header.d-flex.align-items-top
                .name(v-if="row.item.functionContents.hidden")
                  span 匿名
                .name(v-else)
                  span {{ row.item.groupMemberName }}
                .date
                  span {{ convertDate(row.item.datetime) }}
              .body.d-flex.align-items-center
                .information
                  .opinion-relation(v-if="row.item.functionContents.hidden")
                    br
                  .opinion-relation(v-else)
                    div
                      span {{ convertGroupTypeName(row.item.groupTypeId) }}
                      span ・
                      span {{ row.item.groupName }}
                  .opinion-last-message
                    div {{ row.item.functionContents.content }}
                .buttons
                  ContactConfirmSwitch(:value="row.item.functionContents.isFinished" @onSwitch="updateOpinion(row.item)")

        .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
          // 検索
          .search-filter.d-flex.mr-1.align-items-center
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="filter.searchWord" type="search" placeholder="検索ワードを入力してください")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="search-otheruser-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・施設関係者グループ名
                div ・施設関係者ユーザー名
          // フィルタリング
          span.table-option-text 施設関係者グループ:
          .filter(style="max-width:110px;")
            b-form-select(id="other-user-filter-input" v-model="filter.id" :options="filterOptions" size="md")
        .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap.mr-2
          // ページあたりの行数
          span.table-option-text 1ページの行数:
          .per-page
            b-form-select(id="other-user-per-page-select" v-model="perPage" :options="pageOptions" size="md" @change="selectPerPage")
          // ページネーション
          .pagenation
            b-pagination.m-0(v-model="currentPage" :total-rows="rows" :per-page="perPage" :disabled="isLoading" align="center"
              @change="selectPage" hide-goto-end-buttons)

      // right side list
      .message-list.d-flex.flex-column(v-BottomScroll)
        .message-list-title
          div(v-if="currentOpinion && 0 < messages.length")
            span(v-if="currentOpinion.functionContents && currentOpinion.functionContents.hidden") 匿名からのメッセージと回答履歴
            span(v-else) {{ currentOpinion.groupMemberName }}様からのメッセージと回答履歴
        .message-content(v-BottomScroll)
          .message(v-for="message in messages")
            .line-message(:class="{ 'line-left': message.senderType == 0, 'line-right': message.senderType == 1 }")
              .text(style="min-height: 39px;")
                template(v-for="content in createSendMessageContents(message)")
                  .text-content.pre-line(v-if="content.type == 'text'")
                    span {{ content.value }}
                  .link-content.text-center(v-else-if="content.type == 'link'" style="padding: 4px;")
                    a(:href="content.uri" target="_blank") {{ content.value }}
                  .image-content(v-else-if="content.type == 'image'")
                    .image
                      img(:src="content.url" @click="showImage(content.url, content.fileName)")
                  .pdf-content(v-else-if="content.type == 'pdf'")
                    .pdf.flex.flex-send-message
                      .title.pre-line 添付ファイル
                      .text.pre-line
                        span PDFの添付ファイルがあります。
                        br
                        span ファイル名：{{ content.fileName }}
                      .link
                        a(@click="showPdf(content)") PDFファイルを開く
              .date {{ convertDate(message.datetime) }}
          Loading(ref="messageLoading")
        .reply-content(v-if="currentOpinion && 0 < messages.length")
          .d-flex.flex-row.align-items-center.flex-row-reverse
            button.btn.reply-btn(:class="{ 'disable': !existMember }" :disabled="!existMember" @click="onReply") 返信する
            .error-message.mr-2(v-if="existMember == false") ユーザーが削除されているため返信できません

  ImageDownloadModal(v-model="showImageDownloadModal" :url="imageUrl" :fileName="imageFileName")
  PdfModal(v-model="showPdfModal" :pdfUrl="pdfUrl")
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Ref, Vue } from "vue-property-decorator";
import { userStore, itemListFilterStore } from "@/store/store";
import { errorHandle } from "@/errorHandler";
import SystemError from "@/commons/models/SystemError";

import Setting from "../../../../public/setting.json";
import OtherUserOpinionsService from "@/commons/services/OtherUserOpinions";
import OtherUserOpinionMessagesService, { OtherUserOpinionMessageGetModel } from "@/commons/services/OtherUserOpinionMessages";
import OtherUserGroupTypesService from "@/commons/services/OtherUserGroupTypes";
import OtherUserGroupTypeModel from "@/commons/models/OtherUserGroupType";
import OtherUserGroupsService from "@/commons/services/OtherUserGroups";
import OtherUserGroupModel from "@/commons/models/OtherUserGroup";
import { OpinionFunction } from "@/commons/models/Message";
import OtherUserGroupMessageModel from "@/commons/models/OtherUserGroupMessage";
import OtherUserGroupMembersService from "@/commons/services/OtherUserGroupMembers";
import { ReceiveMessagesFunction } from "@/commons/services/Authorization";
import S3UrlService from "@/commons/services/S3Url";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import BottomScroll from "@/pc/basics/BottomScroll";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ContactConfirmSwitch from "@/pc/basics/ContactConfirmSwitch.vue";
import Loading from "@/pc/basics/Loading.vue";
import ImageDownloadModal from "@/pc/basics/ImageDownloadModal.vue";
import PdfModal from "@/pc/basics/PdfModal.vue";

/**
 * 家族からの連絡画面コンポーネント
 */
@Component({
  components: {
    ContactConfirmSwitch,
    PageLoading,
    HelpIcon,
    Loading,
    ImageDownloadModal,
    PdfModal
  },
  directives: {
    BottomScroll
  }
})
export default class OpinionOtherUserListTab extends Vue {
  /** 意見サービス */
  @Inject("OtherUserOpinionsService") otherUserOpinionService!: OtherUserOpinionsService;
  /** 意見メッセージサービス */
  @Inject("OtherUserOpinionMessagesService") otherUserOpinionMessagesService!: OtherUserOpinionMessagesService;
  /** 施設関係者グループ種類サービス */
  @Inject("OtherUserGroupTypesService") otherUserGroupTypesService!: OtherUserGroupTypesService;
  /** 施設関係者グループサービス */
  @Inject("OtherUserGroupsService") otherUserGroupsService!: OtherUserGroupsService;
  /** 施設関係者グループメンバーサービス */
  @Inject("OtherUserGroupMembersService") otherUserGroupMembersService!: OtherUserGroupMembersService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  @Ref()
  messageLoading!: Loading;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** メッセージ送信確認モーダル表示可否 */
  showSendMessageModal: boolean = false;
  /** メッセージ送信完了モーダル表示可否 */
  showSendMessageSuccessModal: boolean = false;
  /** メッセージ送信失敗モーダル表示可否 */
  showSendMessageFaildModal: boolean = false;

  /** 1行あたりの情報配列 */
  items: Array<OtherUserOpinionMessageTableItem> = [];
  /** 列名配列 */
  fields: Array<OtherUserOpinionMessageField> = [];
  /** 意見にひもづくメッセージ */
  messages: Array<OtherUserOpinionMessageGetModel> = [];
  /** 選択中の意見 */
  currentOpinion: OtherUserOpinionMessageTableItem | null = null;

  /** 施設関係者グループ種類MAP */
  otherUserGroupTypeMap: Map<number, string> = new Map<number, string>();

  /** フィルタリング条件 */
  filter: { searchWord: string; id: string } = { searchWord: "", id: "" };
  /** フィルター選択項目 */
  filterOptions: Array<{ value: string; text: string }> = [];
  /** フィルタリング対象カラム名 */
  filterFields: string[] = ["groupId"];
  /** 現在のページ */
  currentPage: number = 1;
  /** 現在取得している件数 */
  currentRows: number = 0;
  /** ページングの全体行数 */
  rows: number = 0;
  /** 1ページあたりの表示行数 */
  perPage: number = Number(Setting.opinion.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.opinion.pageOptions;
  /** ローディング表示可否 */
  isLoading: boolean = false;

  selectedGroupId: number = -1;
  selectedMemberId: number = -1;
  existMember: boolean = false;

  /** 画像モーダルの表示可否 */
  showImageDownloadModal: boolean = false;
  /** 画像モーダルで表示する画像のURL */
  imageUrl: string = "";
  /** 画像のファイル名 */
  imageFileName: string = "";

  /** PDFモーダルの表示可否 */
  showPdfModal: boolean = false;
  /** PDFモーダルで表示するPDFのURL */
  pdfUrl: string = "";

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  public changePerPage(perPage: number): void {
    this.setCookie(perPage);
    return;
  }

  get _receiveMessagesFunction(): ReceiveMessagesFunction | null {
    if (userStore.loginUser) {
      return userStore.loginUser.permissions.receiveMessagesFunction;
    } else {
      return null;
    }
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `opinion-other-user-list-per-page=${perPage}; max-age=${saveSecond};`;
    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    // 画面初期表示時に作成して変更しないものを初期化する
    const fields: Array<OtherUserOpinionMessageField> = this.createFields();
    this.fields = fields;
    // 1ページあたりの表示行数はCookieから取得する。取得できない場合はデフォルト値を使用する
    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.opinion.perPage);
    // フィルタの復元
    this.restoreFilterSetting();

    await this.createView();

    return;
  }

  /**
   * ### ご意見の列名を作成する
   */
  public createFields(): Array<OtherUserOpinionMessageField> {
    const fields: Array<OtherUserOpinionMessageField> = [];
    fields.push({ key: "familyMessage", label: "施設関係者ユーザー", sortable: false, sortDirection: "desc", class: "family-message" });
    return fields;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = Number(cookieMap["opinion-other-user-list-per-page"]);

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  /** フィルタ情報がstoreに存在する場合は復元する */
  private restoreFilterSetting(): void {
    if (this.$options.name && itemListFilterStore.filterMap[this.$options.name] != undefined) {
      this.filter = itemListFilterStore.filterMap[this.$options.name];
    }
    return;
  }

  /**
   * ### 施設関係者グループ種類を取得する
   */
  public async getOtherGroupTypes(): Promise<Array<OtherUserGroupTypeModel>> {
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.otherUserGroupTypesService.get(userStore);
    return otherUserGroupTypes;
  }

  /**
   * ### 画面表示用に施設関係者グループ種類のMAPを作成する
   */
  public createOtherUserGroupTypesMap(otherUserGroupTypes: Array<OtherUserGroupTypeModel>): Map<number, string> {
    let map: Map<number, string> = new Map<number, string>();
    for (const type of otherUserGroupTypes) {
      map.set(type.id, type.name);
    }
    return map;
  }

  /**
   * ### 施設関係者グループを取得する
   */
  public async getOtherUserGroups(): Promise<Array<OtherUserGroupModel>> {
    let response: Array<OtherUserGroupModel> = [];

    try {
      response = await this.otherUserGroupsService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.otherUserGroupsService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / 300);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * 300,
            endIndex: i * 300 + 300
          };
          response = response.concat(await this.otherUserGroupsService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 施設関係者グループフィルター用選択項目
   *
   * - 検索用に施設関係者グループのMAPを作る
   * - アカウント情報から許可されている施設関係者グループIDの配列を取得する
   * - 施設関係者グループ種類から選択項目の施設関係者グループ種類を作成し、フィルターを作成する
   */
  public createFilterOptions(otherUserGroups: Array<OtherUserGroupModel>, otherUserGroupTypeMap: Map<number, string>): Array<{ value: string; text: string }> {
    let filterOptions: Array<{ value: string; text: string }> = [];

    filterOptions.push({
      value: "",
      text: "全て"
    });

    let groupMap: Map<number, OtherUserGroupModel> = new Map<number, OtherUserGroupModel>();
    for (const group of otherUserGroups) {
      groupMap.set(group.id, group);
    }

    const allowedGroups: number[] = userStore.loginUser.permissions.otherUserGroups;
    for (const allowedGroup of allowedGroups) {
      const group: OtherUserGroupModel | undefined = groupMap.get(allowedGroup);
      if (group) {
        const otherUserGroupType: string | undefined = otherUserGroupTypeMap.get(group.groupTypeId);
        const otherUserGroupTypeName: string = otherUserGroupType ? `（${otherUserGroupType}）` : "";
        filterOptions.push({
          value: `${group.id}`,
          text: `${group.name}${otherUserGroupTypeName}`
        });
      }
    }

    // 匿名は施設関係者グループ=0として扱うので、選択項目を追加
    filterOptions.push({
      value: "0",
      text: "匿名"
    });

    return filterOptions;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    this.isLoading = true;

    // 後で使用するため、施設関係者グループ種類をMAP化しておく
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.getOtherGroupTypes();
    const otherUserGroupTypeMap: Map<number, string> = this.createOtherUserGroupTypesMap(otherUserGroupTypes);
    this.otherUserGroupTypeMap = otherUserGroupTypeMap;

    const groups: Array<OtherUserGroupModel> = await this.getOtherUserGroups();
    const filterOptions: Array<{ value: string; text: string }> = this.createFilterOptions(groups, otherUserGroupTypeMap);
    this.filterOptions = filterOptions;

    this.items = [];
    this.currentPage = 1;

    // 全体の行数を非同期で取得する
    this.setRows();

    // ご意見テーブルに渡す各プロパティを作成する
    const opinions: Array<OtherUserGroupMessageModel> = await this.getOpinions();
    const items: Array<OtherUserOpinionMessageTableItem> = this.createItems(opinions);
    this.items = this.items.concat(items);
    this.currentRows = this.items.length;

    this.isLoading = false;

    return;
  }

  /**
   * ### ページング用の全件数を設定する
   */
  public async setRows() {
    try {
      const count: number = await this.otherUserOpinionService.getCount(userStore);
      this.rows = count;
    } catch (error) {
      // 本処理はawaitされない非同期処理なので、共通エラーハンドラーが例外をキャッチしない
      // 例外発生時は自分でエラーハンドラーを呼ぶ
      errorHandle(error, this);
    }

    return;
  }

  /**
   * ### 表示対象の意見を取得する
   */
  public async getOpinions(): Promise<Array<OtherUserGroupMessageModel>> {
    let response: Array<OtherUserGroupMessageModel> = [];

    try {
      const params: any = {
        order: "desc"
      };
      response = await this.otherUserOpinionService.gets(userStore, params);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.otherUserOpinionService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / 300);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number; order: string } = {
            startIndex: i * 300,
            endIndex: i * 300 + 300,
            order: "desc"
          };
          response = response.concat(await this.otherUserOpinionService.gets(userStore, params));
        }
      }
    }

    // 完了しているか否かを設定する
    // 完了日を見て判断する
    for (let opinion of response) {
      if (opinion.functionContents) {
        if (opinion.functionContents.finished) {
          opinion.functionContents.isFinished = true;
        } else {
          opinion.functionContents.isFinished = false;
        }
      }
    }

    return response;
  }

  /**
   * ### ご意見の行を作成する
   */
  public createItems(opinions: Array<OtherUserGroupMessageModel>): Array<OtherUserOpinionMessageTableItem> {
    let items: Array<OtherUserOpinionMessageTableItem> = [];

    for (const opinion of opinions) {
      items.push({
        functionContents: opinion.functionContents,
        groupMemberId: opinion.groupMemberId,
        groupMemberName: opinion.groupMemberName ? opinion.groupMemberName : "",
        groupName: opinion.groupName ? opinion.groupName : "",
        groupTypeId: opinion.groupTypeId ? opinion.groupTypeId : 0,
        datetime: Number(opinion.datetime),
        groupId: opinion.groupId,
        selected: false,
        otherUserOpinionMessagesCaseId: opinion.otherUserOpinionMessagesCaseId
      });
    }

    return items;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   * - ページあたりの表示行数が変わるので表の情報を作り直す
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;
    this.currentOpinion = null;
    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;
    this.currentOpinion = null;
    return;
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: OtherUserOpinionMessageTableItem, filter: { searchWord: string; id: string }): boolean {
    return this.filterGroupId(row, filter) && this.filterSearchWords(row, filter);
  }

  public filterGroupId(row: OtherUserOpinionMessageTableItem, filter: { searchWord: string; id: string }): boolean {
    if (filter.id == "") {
      return true;
    }

    if (row.groupId == Number(filter.id)) {
      return true;
    } else {
      return false;
    }
  }

  public filterSearchWords(row: OtherUserOpinionMessageTableItem, filter: { searchWord: string; id: string }): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundGroupName: boolean = true;
    let foundMemberName: boolean = true;

    for (const word of words) {
      if (row.groupName.indexOf(word) == -1) {
        foundGroupName = false;
      }
      if (row.groupMemberName.indexOf(word) == -1) {
        foundMemberName = false;
      }
    }

    return foundGroupName || foundMemberName;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.rows = filteredItems.length;
    return;
  }

  /**
   * ### 画面で選択したユーザーのメッセージを表示
   */
  public async selectOpinion(opinion: OtherUserOpinionMessageTableItem): Promise<void> {
    this.messageLoading.show();

    // 選択された意見のユーザーが存在するかチェックする
    const member: OtherUserGroupModel | null = await this.getOtherUserGroupMember(opinion.groupId, opinion.groupMemberId);
    this.existMember = member != null ? true : false;

    // 選択されている意見を更新
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].otherUserOpinionMessagesCaseId == opinion.otherUserOpinionMessagesCaseId) {
        this.items[i].selected = true;
        this.currentOpinion = this.items[i];
      } else {
        this.items[i].selected = false;
      }
    }

    // 選択された意見が「未確認」であれば「確認済」に更新する
    const _functionContents: any = opinion.functionContents;
    const contents: OpinionFunction = _functionContents;
    if (!contents.finished) {
      this.updateOpinion(opinion);
    }

    // メッセージ取得中に別の問い合わせが選択されることがありえる
    // そのため、取得したメッセージが選択中の問い合わせ以外のメッセージであれば画面更新しない
    this.selectedGroupId = opinion.groupId;
    this.selectedMemberId = opinion.groupMemberId;
    const messages: Array<OtherUserOpinionMessageGetModel> = await this.createMessages(opinion.otherUserOpinionMessagesCaseId);
    if (0 < messages.length && this.currentOpinion && messages[0].otherUserOpinionMessagesCaseId == this.currentOpinion.otherUserOpinionMessagesCaseId) {
      await this.convertTempFiles(messages);
      this.messages = messages;
    }
    // 画面遷移でコンポーネントが存在しないタイミングがあるため、存在可否をチェックしてからローディングを非表示にする
    if (this.messageLoading) {
      this.messageLoading.hide();
    }

    return;
  }

  /**
   * ### 施設関係者グループメンバーを取得する
   *
   * - 施設関係者グループメンバー単一を取得するAPIはないので、施設関係者グループにひもづくメンバーを取得する
   * - 施設関係者グループメンバーの中からメンバーIDが同一のものを修正対象のメンバーと判断する
   */
  public async getOtherUserGroupMember(groupId: number, memberId: number): Promise<OtherUserGroupModel | null> {
    const members: Array<OtherUserGroupModel> = await this.otherUserGroupMembersService.get(userStore, groupId);
    for (const member of members) {
      if (member.memberId == memberId) {
        return member;
      }
    }
    return null;
  }

  /**
   * ### 指定したCaseIdに紐づく、画面表示用のメッセージを作成する
   */
  public async createMessages(caseId: number): Promise<Array<OtherUserOpinionMessageGetModel>> {
    let messages: Array<OtherUserOpinionMessageGetModel> = await this.otherUserOpinionMessagesService.get(userStore, caseId);
    return messages;
  }

  /**
   * ### 添付ファイルURL変換
   *
   * - 添付ファイルがある場合はそのURLを変換する
   */
  public async convertTempFiles(messages: Array<OtherUserOpinionMessageGetModel>): Promise<void> {
    for (const message of messages) {
      if (message.attachedFiles) {
        for (const file of message.attachedFiles) {
          if (file.url) {
            const convertedUrl: string = await this.convertS3Url(file.url);
            file.url = convertedUrl;
          }
          // URLが存在しないことはあり得ないのでシステムエラー
          else {
            throw new SystemError("attachedFiles.type is invalid. sortKey = " + message.otherUserOpinionMessagesCaseId);
          }
        }
      }
    }
    return;
  }

  /**
   * ### LINEメッセージ情報のメッセージ種別から判断して、画面表示用のメッセージを作成する
   */
  private async convertS3Url(url: string): Promise<string> {
    // 画像URLが渡されてきた場合はS3にある画像の公開設定を行ってそのURLを画面で使用する
    let publicUrl: string = "";
    try {
      publicUrl = await this.s3UrlService.get(userStore, Setting.backets.imageExpireHour, url);
    } catch (error) {
      // S3の画像が削除されてしまう場合があり得るためシステムエラーにはしない
      console.error("S3 image not fount");
    }
    return publicUrl;
  }

  public createSendMessageContents(message: OtherUserOpinionMessageGetModel): Array<{ type: string; value: string; uri?: string; url?: string; fileName?: string }> {
    // contentが存在しない場合は空配列を返す
    if (!message.content) {
      return [];
    }

    // template側でlinkボタンとテキストを判別するためにtypeを持たせる
    let contents: Array<{ type: string; value: string; uri?: string; url?: string; fileName?: string }> = [];
    const splitedContent: string[] = message.content.split("\n");
    let buttonCount: number = 1;

    for (const message of splitedContent) {
      let content: { type: string; value: string; uri?: string };

      // リンクボタンメッセージ(ボタン名指定)
      // 先頭に半角全角スペースがあるだけの場合は無視して扱い、それ以外はテキスト文字列として扱う
      if (message.match(/^\[(.*)\]\((.*)\)$/)) {
        const linkRegex = /\[(.*?)\]\((.*?)\)/g;
        const links: Array<{ name: string; url: string }> = [];
        let match: any;

        while ((match = linkRegex.exec(message)) !== null) {
          const name = match[1] ? match[1] : null;
          const url = match[2] ? match[2] : null;
          links.push({ name, url });
        }

        if (links.length == 1 && links[0].name != null && links[0].url != null) {
          content = {
            type: "link",
            value: `${links[0].name}`,
            uri: links[0].url
          };
          contents.push(content);
        } else {
          content = {
            type: "text",
            value: message
          };
          contents.push(content);
        }
      }
      // リンクボタンメッセージ(ボタン名指定無し)
      // 先頭に半角全角スペースがあるだけの場合はURLとして扱い、それ以外はテキスト文字列として扱う
      else if (message.match(/^\s*(http|https):\/\/.+/)) {
        // 前後の半角全角スペースを取り除き、URLデコード&エンコードを考慮したURIを作成する
        const uri: string = message.replace(/^\s+|\s+$/g, "");
        const decodedUri: string = decodeURI(uri);
        const encodedUri: string = encodeURI(decodedUri);

        content = {
          type: "link",
          value: `リンク その${buttonCount}`,
          uri: encodedUri
        };
        buttonCount++;
        contents.push(content);
      }
      // テキストメッセージ
      else {
        const convertedMessage: string = message == "" ? "　" : message;
        content = {
          type: "text",
          value: convertedMessage
        };
        contents.push(content);
      }
    }

    // 添付ファイルがある場合は添付ファイルもコンテンツとする
    if (message.attachedFiles) {
      for (const file of message.attachedFiles) {
        if (file.type == "image") {
          contents.push({
            type: file.type,
            value: "",
            url: file.url,
            fileName: file.name
          });
        } else if (file.type == "pdf") {
          contents.push({
            type: file.type,
            value: "",
            url: file.url,
            fileName: file.name
          });
        }
      }
    }

    return contents;
  }

  /**
   * ### 画像をモーダル表示する
   */
  public showImage(url: string, fileName: string): void {
    this.imageUrl = url;
    const opinion = this.currentOpinion as OtherUserOpinionMessageTableItem;
    this.imageFileName = `HitomeQコネクト-受信メッセージ（家族連絡）-${opinion.groupName}（${opinion.groupMemberName}）-${fileName}`;
    this.showImageDownloadModal = true;
    return;
  }

  /**
   * ### PDFをモーダル表示する
   */
  public showPdf(file: { type: string; url: string }): void {
    this.pdfUrl = file.url;
    this.showPdfModal = true;
    return;
  }

  /**
   * ### 意見の状態を更新する
   */
  public async updateOpinion(opinion: OtherUserOpinionMessageTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    const updateOpinion: OtherUserGroupMessageModel = this.createUpdateParam(opinion);
    await this.otherUserOpinionMessagesService.patch(userStore, opinion.otherUserOpinionMessagesCaseId, updateOpinion);

    // サイドメニューの未完了バッジを更新する
    this.$emit("refresh");

    this.isBusy = false;

    return;
  }

  /**
   * ### 意見更新パラメータを作成する
   */
  public createUpdateParam(opinion: any): OtherUserGroupMessageModel {
    // 意見状態の確認はfinishedに日時が格納されることと同義なので、finishedに日時を入れて更新する
    // 意見状態を未確認にする場合は0を格納してAPIに渡すIFになっている
    const _functionContents: any = opinion.functionContents;
    const contents: OpinionFunction = _functionContents;

    // データ破損でnullが格納されている場合があるため、チェックして空文字に置き換える
    contents.content = contents.content ? contents.content : "";

    if (!contents.finished) {
      const date: Date = new Date();
      contents.finished = this.$dateUtil.convertDateToNumber(date, "yyyymmddhhMMss000");
      contents.isFinished = true;
    } else {
      contents.finished = 0;
      contents.isFinished = false;
    }

    opinion.writtenBy = userStore.loginUser.name;
    opinion.writerId = userStore.loginUser.userId;

    return opinion;
  }

  /**
   * ### 返信ボタン押下イベントを親コンポーネントに通知する
   */
  public onReply(): void {
    this.$emit("onReply", {
      currentOpinion: this.currentOpinion,
      messages: this.messages
    });
  }

  /**
   * ### 新規投稿日時を画面表示用の文字列に変換する
   */
  public convertDate(date: number) {
    const convertedDate: string = this.$dateUtil.convertNumberToString(date, "yyyy/mm/dd hh:MM");
    return convertedDate;
  }

  /**
   * ### グループ種類IDからグループ名に変換する
   */
  public convertGroupTypeName(id: number): string {
    const groupTypeName: string | undefined = this.otherUserGroupTypeMap.get(id);
    return groupTypeName ? groupTypeName : "";
  }

  /**
   * ### 画面情報を再取得する
   */
  public async refresh(): Promise<void> {
    await this.createView();
    return;
  }

  setFilterSetting() {
    // 画面を離れる前に現在のフィルタリング条件をVuexに保存
    if (this.$options.name) {
      itemListFilterStore.setFilter({ url: this.$options.name, filter: this.filter });
    }
    return;
  }
}

export interface OtherUserOpinionMessageField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

export interface OtherUserOpinionMessageTableItem {
  functionContents: { hidden: boolean; familyRelation: string; content: string; isFinished: boolean };
  groupMemberId: number;
  groupMemberName: string;
  groupName: string;
  groupTypeId: number;
  datetime: number;
  groupId: number;
  selected: boolean;
  otherUserOpinionMessagesCaseId: number;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.receive-message-list-tab {
  margin-left: auto;
  margin-right: auto;

  @mixin title() {
    background-color: $bg-header;
    padding: 5px;
    min-height: 32px;
    font-weight: bold;
    text-align: center;
  }

  .box {
    margin-bottom: 0;
  }

  .opinion-history {
    // デフォルトフォントサイズを指定する
    font-size: 16px;
    // 外枠はここで描画させる
    border: solid 1px $border-darkgray;

    // 左側、ユーザーリスト
    .receive-message-list {
      min-width: 50%;
      max-width: 50%;

      .opinion-row {
        padding: 6px 15px;
      }
      .header {
        .name {
          width: calc(100% - 134px);
          padding-right: 12px;
          font-weight: bold;
        }
        .date {
          width: 134px;
          font-size: 14px;
          text-align: right;
        }
      }
      .body {
        .information {
          width: calc(100% - 68px);
          padding-right: 12px;

          .opinion-relation,
          .opinion-last-message {
            div {
              font-size: 14px;
            }
          }
          .opinion-last-message {
            div {
              max-width: calc(14px * 9); // iPadで表示崩れが起きるため、9文字以降は省略
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
        .buttons {
          width: 68px;
        }
      }
      // テーブルのオプション
      .table-options {
        margin-bottom: 12px;

        .table-option-text {
          margin-right: 8px;
        }
        .filter {
          margin-right: 8px;
          width: 160px;
        }
        .per-page {
          margin-right: 8px;
          width: 64px;
        }
      }
    }

    // 右側、メッセージリスト
    .message-list {
      min-width: 50%;
      max-width: 50%;
      overflow-y: auto;
      overflow-x: auto;
      border-left: solid 1px $border-darkgray;

      .message-list-title {
        @include title();
        border-bottom: solid 1px $border-lightgray;
        min-height: 35px;
      }

      .message-content {
        overflow-y: scroll;
        overflow-x: auto;
        position: relative;
        max-height: calc(100vh - 324px);
        // 背景色
        background-color: $bg-message;

        .message {
          padding: 10px 0 10px 0;
          // botの発言
          .line-left {
            position: relative;
            display: inline-block;
            margin-bottom: 5px;
            clear: both;
            margin-left: 30px;
            max-width: 740px;
            // 発言本文
            .text {
              padding: 10px;
              border-radius: 20px;
              background-color: $bg-message-bot;
              margin: 0;
              margin-right: 80px;
              // LINEの吹き出しのように見せるために、CSSで図形を描画
              &::after {
                content: "";
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                left: -10px;
                top: 10px;
                border-right: 20px solid $bg-message-bot;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
              }
            }
            // 日付部分
            .date {
              color: $date-font-color;
              text-align: left;
              font-size: 14px;
              font-weight: bold;
            }
          }
          // 自分の発言
          .line-right {
            position: relative;
            margin-top: 5px;
            float: right;
            clear: both;
            margin-right: 30px;
            max-width: 740px;
            // 発言本文
            .text {
              padding: 10px;
              border-radius: 20px;
              background-color: $bg-message-mine;
              color: rgba(255, 255, 255, 1);
              margin: 0;
              margin-left: 80px;
              // LINEの吹き出しのように見せるために、CSSで図形を描画
              &::after {
                content: "";
                position: absolute;
                display: block;
                width: 0;
                height: 0;
                right: -10px;
                top: 10px;
                border-left: 20px solid $bg-message-mine;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
              }
            }
            // 日付部分
            .date {
              color: $date-font-color;
              text-align: right;
              font-size: 14px;
              font-weight: bold;
            }
          }
          // LINE風に表示を行うため、vueがメッセージの情報を取得後、スクロールバーの位置を一番下に移動させている
          // vueがDOM要素を作成した後、img要素のsrc属性のURLにGETが走り、画像が取得される
          // 画像の大きさを固定しておかなかった場合、img要素は動的に高さが変わり、スクロールバーの長さが変わる
          // スクロールバーの長さが変わると、スクロール位置もずれてしまい、位置が一番下ではなくなってしまう
          // これを回避するため、画像を表示するdiv要素の高さおよびimg要素の高さを固定し、img要素の高さが動的に変わるのを防ぐ
          .image {
            // 「ここで高さを固定しないと、問題が発生するため、高さ固定」とあるが、max-heightで問題がないか確認する
            // height: 320px;
            max-height: 320px;
            img {
              // 画像サイズは高さ固定
              height: 300px;
              max-width: 700px;
            }
            cursor: pointer;
          }
          .link {
            padding: 8px;
            cursor: pointer;
            a {
              color: $font-key-color;
            }
          }
        }
      }
      .reply-content {
        padding: 8px;
      }
    }
  }
}
</style>
